export default __webpack_public_path__ + "static/media/ZoomOut.21277723.mp3";